import api from "./index";

// Marketing Campaigns API
export const getCampaigns = (params = {}) =>
  api.get("property-management/campaigns/", { params });

export const getCampaign = (id) =>
  api.get(`property-management/campaigns/${id}/`);

export const createCampaign = (data) => {
  if (data instanceof FormData) {
    return api.post("property-management/campaigns/create/", data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
  return api.post("property-management/campaigns/create/", data);
};

export const updateCampaign = (id, data) =>
  api.put(`property-management/campaigns/${id}/`, data);

export const patchCampaign = (id, data) =>
  api.patch(`property-management/campaigns/${id}/`, data);

export const deleteCampaign = (id) =>
  api.delete(`property-management/campaigns/${id}/`);

export const startCampaign = (id) =>
  api.post(`property-management/campaigns/${id}/start/`);

export const pauseCampaign = (id) =>
  api.post(`property-management/campaigns/${id}/pause/`);

export const completeCampaign = (id) =>
  api.post(`property-management/campaigns/${id}/complete/`);

export const updateCampaignMetrics = (id, data) =>
  api.patch(`property-management/campaigns/${id}/metrics/`, data);

export const getCampaignStats = (params = {}) =>
  api.get("property-management/campaigns/stats/", { params });

export const getCampaignProperties = (params = {}) =>
  api.get("property-management/campaigns/properties/", { params });

export const getRecentCampaignAgents = () =>
  api.get("property-management/campaigns/recent-agents/");

// Campaign Manager's hand-off to PrintForce. Sends this one listing across now
// and answers with what happened, since PrintForce report nothing back to us.
export const sendPropertyToPrintForce = (propertyId) =>
  api.post(`property-management/campaigns/properties/${propertyId}/printforce/`);

// Media Wizard's own campaign id, pasted in by an agent who is already looking
// at the campaign. Their feed is one way, so this is the only route by which
// their id ever reaches us, and it is what makes Campaign Details open the exact
// page instead of their site root. An empty string clears a wrong one.
export const setPrintForceCampaignId = (propertyId, campaignId) =>
  api.post(
    `property-management/campaigns/properties/${propertyId}/printforce/campaign-id/`,
    { campaign_id: campaignId }
  );

// Legacy/AI Voice Caller endpoints (keeping these to avoid breaking AiCallCenter etc)
export const createAgent = (agentData) =>
  api.post("api/ai-voice-caller/voice-agents/", agentData);

export const getAgent = (id) => api.get(`api/ai-voice-caller/voice-agents/${id}`);

export const updateAgent = (id, data) =>
  api.put(`api/ai-voice-caller/voice-agents/${id}/`, data);

// Questions API
export const createQuestion = (agentId, data) =>
  api.post(`api/ai-voice-caller/voice-agents/${agentId}/questions/`, data);

export const updateQuestion = (agentId, questionId, data) =>
  api.put(
    `api/ai-voice-caller/voice-agents/${agentId}/questions/${questionId}/`,
    data
  );

export const getQuestions = (agentId) =>
  api.get(`api/ai-voice-caller/voice-agents/${agentId}/questions/`);

// Intents API
export const createIntent = (agentId, data) =>
  api.post(`api/ai-voice-caller/voice-agents/${agentId}/intents/`, data);

export const updateIntent = (agentId, intentId, data) =>
  api.put(`api/ai-voice-caller/voice-agents/${agentId}/intents/${intentId}/`, data);

export const getIntents = (agentId) =>
  api.get(`api/ai-voice-caller/voice-agents/${agentId}/intents/`);

export const deleteQuestions = (agentId, questionId) =>
  api.delete(
    `api/ai-voice-caller/voice-agents/${agentId}/questions/${questionId}/`
  );

export const deleteIntent = (agentId, intentId) =>
  api.delete(`api/ai-voice-caller/voice-agents/${agentId}/intents/${intentId}/`);

// Scripts API
export const createScript = (agentId, data) =>
  api.post(`api/ai-voice-caller/voice-agents/${agentId}/scripts/`, data);

export const getScripts = (agentId) =>
  api.get(`api/ai-voice-caller/voice-agents/${agentId}/scripts/`);

export const updateScript = (agentId, scriptId, data) =>
  api.put(`api/ai-voice-caller/voice-agents/${agentId}/scripts/${scriptId}/`, data);

export const deleteScript = (agentId, scriptId) =>
  api.delete(`api/ai-voice-caller/voice-agents/${agentId}/scripts/${scriptId}/`);

// Property Lead Queues API
export const getPropertyLeadQueues = (params = {}) =>
  api.get("api/ai-voice-caller/property-lead-queues/", { params });

export const postPropertyLeadQueue = (data) =>
  api.post("api/ai-voice-caller/property-lead-queues/", data);

export const putPropertyLeadQueue = (id, data) =>
  api.put(`api/ai-voice-caller/property-lead-queues/${id}/`, data);

export const deletePropertyLeadQueue = (id) =>
  api.delete(`api/ai-voice-caller/property-lead-queues/${id}/`);
